import React, {useEffect, useState} from "react";
import "./PlansSection.scss";
import PlansTable from "./PlansTable";
import useFetch, {baseUrl} from "../../../hooks/useFetch";
import Tabination from "../../ReusableComponent/Tabination/Tabination";
import {dollarUS} from "../../../utils/helpers/string";

function PlansSection({selectedPlanId, handleScrollToCheckout, isLoading, apiData}) {
  // State declarations
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [uniqueAccountSizes, setUniqueAccountSizes] = useState([]);
  const [allPlans, setAllPlans] = useState([]);
  const [activeStepTab, setActiveStepTab] = useState(0);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedAccountSize, setSelectedAccountSize] = useState(null);
  const [selectedPlans, setSelectedPlans] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [swiperRef, setSwiperRef] = useState(null);

  console.log("selectedPlans", selectedPlans);

  // Log apiData and selectedPlans changes
  // useEffect(() => {
  //   console.log("apiData:", apiData);
  //   console.log("selectedPlans updated:", {
  //     selectedPlans,
  //     selectedPlanId,
  //     selectedCategory: filteredCategories[activeTab],
  //     selectedAccountSize,
  //     activeStepTab,
  //     activeTab,
  //   });
  // }, [selectedPlans, selectedPlanId, filteredCategories, activeTab, selectedAccountSize, activeStepTab, apiData]);

  // Helper function to calculate unique account balances
  const calculateUniqueAccountBalances = (categories, data) => {
    const accountBalances = [];
    categories.forEach((category) => {
      const actualCategory = category.startsWith("Alpha Pro") ? "Alpha Pro" : category;
      if (data[actualCategory]) {
        data[actualCategory].forEach((item) => {
          accountBalances.push(item.account_balance);
        });
      }
    });
    return [...new Set(accountBalances)];
  };

  // Helper function to collect all plans
  const allPlansArrayFunction = (categories, data) => {
    const allPlansArray = [];
    categories.forEach((category) => {
      const actualCategory = category.startsWith("Alpha Pro") ? "Alpha Pro" : category;
      if (data[actualCategory]) {
        data[actualCategory].forEach((item) => {
          allPlansArray.push(item);
        });
      }
    });
    return allPlansArray;
  };

  // Helper function to filter categories by step
  const filterCategoriesByStep = (step) => {
    if (!apiData) {
      console.warn("No apiData available for filterCategoriesByStep");
      return [];
    }
    const categories = Object.keys(apiData)?.filter((category) => apiData[category]?.some((item) => item.steps === step) && category !== "Free Trial");

    const updatedCategories = [];
    categories.forEach((category) => {
      if (category === "Alpha Pro") {
        if (apiData["Alpha Pro"].some((item) => item.profit_target_in_percent === 6 && item.steps === step)) {
          updatedCategories.push("Alpha Pro6%");
        }
        if (apiData["Alpha Pro"].some((item) => item.profit_target_in_percent === 8 && item.steps === step)) {
          updatedCategories.push("Alpha Pro8%");
          updatedCategories.push("Alpha Pro10%"); // Include Alpha Pro10% if Alpha Pro8% exists
        }
      } else {
        updatedCategories.push(category);
      }
    });

    console.log("Filtered Categories for step", step, ":", updatedCategories);
    return updatedCategories;
  };

  // Helper function to find a plan by ID
  const findObjectById = (data, id) => {
    for (const key in data) {
      if (Array.isArray(data[key])) {
        for (const plan of data[key]) {
          if (plan.id === id) {
            return plan;
          }
        }
      }
    }
    return null;
  };

  // Centralized function to filter plans
  const filterPlans = (category, accountSize, step) => {
    const actualCategory = category.startsWith("Alpha Pro") ? "Alpha Pro" : category;

    let plans = [];

    if (actualCategory.startsWith("Alpha Three")) {
      let AlphaThreeAccountSize = Number(accountSize);

      if (AlphaThreeAccountSize === 5000) {
        AlphaThreeAccountSize = 10000;
      }

      plans = apiData?.[actualCategory]?.filter((item) => Number(item.account_balance) === AlphaThreeAccountSize) || [];

      console.log("Alpha Three Plans:", {category, accountSize, AlphaThreeAccountSize, plans});
    } else {
      plans =
        apiData?.[actualCategory]?.filter((item) => {
          const matchBalance = item?.account_balance === accountSize;
          const matchStep = item?.steps === step;

          if (category.startsWith("Alpha Pro")) {
            if (category === "Alpha Pro6%" && item?.profit_target_in_percent === 6) {
              return matchBalance && matchStep;
            } else if (category === "Alpha Pro8%" && item?.profit_target_in_percent === 8) {
              return matchBalance && matchStep;
            } else if (category === "Alpha Pro10%" && item?.profit_target_in_percent === 8) {
              return matchBalance && matchStep;
            }
            return false;
          }

          return matchBalance && matchStep;
        }) || [];

      // Transform plans for Alpha Pro10%
      if (category === "Alpha Pro10%") {
        plans = plans.map((plan) => ({
          ...plan,
          profit_target_in_percent: 10,
          Price: plan?.price_alpha_pro_10per || plan?.Price,
          name: plan?.name.replace("8%", "10%"),
        }));
      }
    }

    console.log("Filtering Plans:", {category, accountSize, step, plans});
    return plans;
  };

  // Handle plan tab change
  const handlePlanTabChange = (index) => {
    if (index !== activeTab) {
      setActiveTab(index);
      if (filteredCategories.length > 0 && selectedAccountSize) {
        const selectedCategory = filteredCategories[index];
        const correspondingPlans = filterPlans(selectedCategory, selectedAccountSize, activeStepTab + 1);
        setSelectedPlans(correspondingPlans);
        console.log("Tab Changed:", {selectedCategory, correspondingPlans});
      } else {
        console.log("Tab Changed: No plans due to missing category or account size");
        setSelectedPlans([]);
      }
    }
  };

  // Handle account size selection
  const handleAccountSizeSelect = (index) => {
    const accountSize = uniqueAccountSizes[index];
    setSelectedAccountSize(accountSize);
    setActiveIndex(index);
    if (swiperRef) {
      swiperRef.slideTo(index);
    }
    if (filteredCategories.length > 0) {
      const selectedCategory = filteredCategories[activeTab];
      const correspondingPlans = filterPlans(selectedCategory, accountSize, activeStepTab + 1);
      setSelectedPlans(correspondingPlans);
      console.log("Account Size Changed:", {selectedCategory, accountSize, correspondingPlans});
    }
  };

  // Handle selectedPlanId changes
  useEffect(() => {
    if (selectedPlanId && apiData) {
      console.log("selectedPlanId useEffect triggered:", {selectedPlanId});
      const plan = findObjectById(apiData, selectedPlanId);
      if (plan) {
        const step = plan.steps;

        const filtered = filterCategoriesByStep(step);

        // Prioritize UI's selectedCategory
        const currentCategory = filteredCategories[activeTab] || (plan.plan_type === "Alpha Pro" ? `Alpha Pro${plan.profit_target_in_percent}%` : plan.plan_type);
        const displayCategory =
          currentCategory === "Alpha Pro10%"
            ? "Alpha Pro10%"
            : filtered.includes(currentCategory)
            ? currentCategory
            : filtered[0] || (plan.plan_type === "Alpha Pro" ? `Alpha Pro${plan.profit_target_in_percent}%` : plan.plan_type);

        // Update states conditionally
        if (activeStepTab !== step - 1) {
          setActiveStepTab(step - 1);
        }
        if (JSON.stringify(filteredCategories) !== JSON.stringify(filtered)) {
          setFilteredCategories(filtered);
        }

        const categoryIndex = filtered.findIndex((category) => category === displayCategory);
        if (categoryIndex >= 0 && activeTab !== categoryIndex) {
          setActiveTab(categoryIndex);
        } else if (categoryIndex < 0 && filtered.length > 0) {
          setActiveTab(0);
        }

        const accountBalance = plan.account_balance;
        if (selectedAccountSize !== accountBalance) {
          setSelectedAccountSize(accountBalance);
          const accountSizes = calculateUniqueAccountBalances(filtered, apiData);
          const newAccountSizeIndex = accountSizes.indexOf(accountBalance);
          if (newAccountSizeIndex >= 0) {
            setActiveIndex(newAccountSizeIndex);
          }
        }

        const correspondingPlans = filterPlans(displayCategory, accountBalance, step);
        if (correspondingPlans.length === 0) {
          console.warn("No plans found, trying fallback:", {displayCategory, accountBalance, step});
          const fallbackPlans = currentCategory !== displayCategory ? filterPlans(currentCategory, accountBalance, step) : selectedPlans;
          setSelectedPlans(fallbackPlans.length > 0 ? fallbackPlans : correspondingPlans);
        } else {
          setSelectedPlans(correspondingPlans);
        }
        console.log("Selected Plan ID:", {selectedPlanId, displayCategory, accountBalance, step, correspondingPlans});
      } else {
        console.warn("Plan not found for selectedPlanId:", selectedPlanId);
        setSelectedPlans(selectedPlans);
      }
    }
  }, [selectedPlanId, apiData]);

  // Determine available steps
  const availableSteps = apiData ? [...new Set(Object.values(apiData).flatMap((category) => category.map((item) => item.steps)))].sort() : [1, 2, 3];

  // Handle step tab changes
  useEffect(() => {
    if (apiData && activeStepTab !== null) {
      const step = activeStepTab + 1;
      const filtered = filterCategoriesByStep(step);
      setFilteredCategories(filtered);

      console.log("bstep", step, filtered);

      if (filtered.length > 0) {
        const currentCategory = filteredCategories[activeTab];
        const newTabIndex = filtered.includes(currentCategory) ? filtered.indexOf(currentCategory) : 0;
        setActiveTab(newTabIndex);

        const accountSizes = calculateUniqueAccountBalances(filtered, apiData);
        setUniqueAccountSizes(accountSizes);

        const plans = allPlansArrayFunction(filtered, apiData);
        setAllPlans(plans);

        if (!selectedAccountSize || !accountSizes.includes(selectedAccountSize)) {
          const fallbackAccountSize = accountSizes[0];
          setSelectedAccountSize(fallbackAccountSize);
          setActiveIndex(0);
        } else {
          const newAccountSizeIndex = accountSizes.indexOf(selectedAccountSize);
          setActiveIndex(newAccountSizeIndex);
        }

        const selectedCategory = filtered[newTabIndex];
        const correspondingPlans = filterPlans(selectedCategory, selectedAccountSize || accountSizes[0], step);
        setSelectedPlans(correspondingPlans);
        console.log("bcorrespondingPlans:", correspondingPlans);

        if (correspondingPlans.length === 0) {
          console.warn("No plans available for step, falling back to previous plans:", {step, selectedCategory});
          // Fallback to previous plans or first available step
          setSelectedPlans(selectedPlans);
        }
      } else {
        console.log("Step Changed: No categories available for step", step);
        // setSelectedPlans([]);
        setUniqueAccountSizes([]);
        setAllPlans([]);
      }
    }
  }, [activeStepTab, apiData]);

  // Sync swiper with activeIndex
  useEffect(() => {
    if (swiperRef) {
      swiperRef.slideTo(activeIndex);
    }
  }, [activeIndex, swiperRef]);

  return (
    <div className="ps_wrapper">
      {isLoading && <div>Loading...</div>}
      <div className="ps_intro">
        <h1>
          Still Not Sure? <span className="gradientText">Check out our other plans</span>
        </h1>
        <p>Choose the evaluation based on your preference to become an Alpha Trader.</p>

        <div className="plan_select step_select">
          <Tabination
            tabItems={availableSteps.map((step) => ({name: `${step} Step`}))}
            activeTab={activeStepTab}
            setActiveTab={setActiveStepTab}
            variant={2}
          />
        </div>

        {filteredCategories.length > 0 ? (
          <div className="plan_select plan_selector_container">
            <Tabination
              tabItems={filteredCategories?.map((plan) => ({name: plan}))}
              activeTab={activeTab}
              setActiveTab={handlePlanTabChange}
              variant={2}
            />
          </div>
        ) : (
          <div>No categories available for this step.</div>
        )}

        {uniqueAccountSizes.length > 0 && (
          <div className="plan_select account_size_select">
            <Tabination
              tabItems={uniqueAccountSizes.map((size) => ({
                name: `${dollarUS(size)}`,
              }))}
              activeTab={activeIndex}
              setActiveTab={handleAccountSizeSelect}
              variant={2}
            />
          </div>
        )}
      </div>

      {selectedPlans?.length > 0 ? (
        <PlansTable
          handleScrollToCheckout={handleScrollToCheckout}
          plansData={selectedPlans}
          activeStep={activeStepTab + 1}
          selectedCategory={filteredCategories[activeTab]}
          activeTab={activeTab}
          allPlans={allPlans}
          uniqueAccountSizes={uniqueAccountSizes}
          handleAccountSizeSelect={handleAccountSizeSelect}
          setSwiperRef={setSwiperRef}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
        />
      ) : (
        <div>No plans available for the selected category and account size.</div>
      )}
    </div>
  );
}

export default PlansSection;
